import { useState, useEffect } from "react";
import { getVehicleMakes } from "../../../services/vehicleMakes";

export const useVehicleState = (vehicle) => {
  const [profile, setProfile] = useState(vehicle.profile);
  const [make, setMake] = useState(vehicle.basicInfo.make);
  const [model, setModel] = useState(vehicle.basicInfo.model);
  const [color, setColor] = useState(vehicle.color);
  const [bodyStyle, setBodyStyle] = useState(vehicle.bodyStyle);
  const [changeHistory, setChangeHistory] = useState(
    vehicle.changeHistory || []
  );
  const [g80ConversionKit, setG80ConversionKit] = useState(
    vehicle.g80ConversionKit || "No"
  );
  const [makes, setMakes] = useState([]);
  const [loadingMakes, setLoadingMakes] = useState(true);
  const [errorMakes, setErrorMakes] = useState(null);
  const [basicInfoMessage, setBasicInfoMessage] = useState(null);
  const [profileMessage, setProfileMessage] = useState(null);

  // Reset all state when vehicle changes
  useEffect(() => {
    // Reset all vehicle-specific state
    setProfile(vehicle.profile || "");
    setMake(vehicle.basicInfo.make || "");
    setModel(vehicle.basicInfo.model || "");
    setColor(vehicle.color || "");
    setBodyStyle(vehicle.bodyStyle || "");
    setChangeHistory(vehicle.changeHistory || []);
    setG80ConversionKit(vehicle.g80ConversionKit || "No");

    // Clear any messages or errors
    setBasicInfoMessage(null);
    setProfileMessage(null);
    setErrorMakes(null);
  }, [vehicle]);

  useEffect(() => {
    fetchMakes();
  }, []);

  const fetchMakes = async () => {
    try {
      setLoadingMakes(true);
      const makesData = await getVehicleMakes();
      setMakes(makesData);
      setErrorMakes(null);
    } catch (err) {
      console.error("Error fetching makes:", err);
      setErrorMakes("Failed to load vehicle makes");
    } finally {
      setLoadingMakes(false);
    }
  };

  // Clear messages after 3 seconds
  useEffect(() => {
    if (basicInfoMessage) {
      const timer = setTimeout(() => {
        setBasicInfoMessage(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [basicInfoMessage]);

  useEffect(() => {
    if (profileMessage) {
      const timer = setTimeout(() => {
        setProfileMessage(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [profileMessage]);

  return {
    profile,
    setProfile,
    make,
    setMake,
    model,
    setModel,
    color,
    setColor,
    bodyStyle,
    setBodyStyle,
    changeHistory,
    setChangeHistory,
    g80ConversionKit,
    setG80ConversionKit,
    makes,
    loadingMakes,
    errorMakes,
    basicInfoMessage,
    setBasicInfoMessage,
    profileMessage,
    setProfileMessage,
  };
};
